import React, { useState } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { helper } from '../common/helper.js';
import styled from 'styled-components';
import TuneIcon from '@mui/icons-material/Tune';

function FilterActor(props) {

    const history = useHistory();
    const [openFilter, setOpenFilter] = useState(false);

    const url = (key, item) => {
        if (key === "sexe")
            return `${props.baseUrl}&sexe=${item.key}&sort=${props.params.sort}&direction=${props.params.direction}&search=${props.searchValue || ''}`;
        if (key === "sort")
            return `${props.baseUrl}&sexe=${props.params.sexe}&sort=${item.key}&direction=${props.params.direction}&search=${props.searchValue || ''}`;
        if (key === "direction")
            return `${props.baseUrl}&sexe=${props.params.sexe}&sort=${props.params.sort}&direction=${item.key}&search=${props.searchValue || ''}`;
    }

    const paramURL = (tag) => {
        return `/actors?${tag}&size=${props.params.size}&sort=${props.params.sort}&direction=${props.params.direction}&search=${props.searchValue || ''}`;
    }

    const onTagChange = (e) => {
        var temp = props.tags.selected.map(a => a.id);
        temp.push(e.target.value);
        history.push(paramURL(helper.query(temp, "tag")));
        props.tag(temp);
    }

    const onRemoveTag = (index) => {
        var temp = props.tags.selected.map(a => a.id);
        var i = temp.indexOf(index);
        temp.splice(i, 1);
        history.push(paramURL(helper.query(temp, "tag")));
        props.tag(temp);
    }

    return (
        <div style={{ padding: '16px 12px' }}>
            <FilterHeader>
                <SearchContainer>
                    <SearchInput
                        placeholder="Search actors…"
                        value={props.searchValue || ''}
                        onChange={e => props.onSearchChange(e.target.value)}
                        onKeyDown={e => e.key === 'Enter' ? props.onSearchSubmit(e.target.value) : ''}
                    />
                    <ModernButton onClick={() => props.onSearchSubmit(props.searchValue || '')}>Search</ModernButton>
                    {props.searchValue && (
                        <ClearButton onClick={() => { props.onSearchChange(''); props.onSearchSubmit(''); }}>✕</ClearButton>
                    )}
                </SearchContainer>
                <FilterButtonContainer>
                    <FilterToggleButton onClick={() => setOpenFilter(!openFilter)} isOpen={openFilter}>
                        <TuneIcon fontSize="small" />
                        Filters
                    </FilterToggleButton>
                </FilterButtonContainer>
            </FilterHeader>

            {openFilter && (
                <FilterPanel>
                    <FilterGrid>
                        {props.filters.map(filter => (
                            <FilterGroup key={filter.key}>
                                <FilterLabel>{filter.title}</FilterLabel>
                                {filter.items.map(item => (
                                    <FilterLink
                                        key={item.key}
                                        to={url(filter.key, item)}
                                        onClick={() => props.filterRefresh(filter.key, item)}
                                        className={item.key === filter.selected ? 'selected' : ''}
                                    >
                                        {item.value}
                                    </FilterLink>
                                ))}
                            </FilterGroup>
                        ))}

                        {!props.isFetching && props.tags != null ?
                            <FilterGroup>
                                <FilterLabel>Tags</FilterLabel>
                                <select className="custom-select custom-select-sm" onChange={onTagChange}>
                                    <option>Select a tag</option>
                                    {props.tags.available.map(tag =>
                                        <option key={tag.id} value={tag.id}>{tag.name}</option>
                                    )}
                                </select>
                                <div className="pt-1">
                                    {props.tags.selected.map(tag =>
                                        <Link to="#" key={tag.id} className="badge badge-dark m-1" onClick={() => onRemoveTag(tag.id)}>{tag.name}</Link>
                                    )}
                                </div>
                            </FilterGroup>
                            : <FilterGroup><Spinner animation="border" variant="danger" size="sm" /></FilterGroup>}
                    </FilterGrid>
                </FilterPanel>
            )}
        </div>
    );
}

// --- Styled components (matching FilterScene) ---

const FilterHeader = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  align-items: center;
`;

const SearchContainer = styled.div`
  flex: 1;
  display: flex;
  gap: 8px;
`;

const SearchInput = styled.input`
  flex: 1;
  padding: 10px 14px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
  background-color: #ffffff;

  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }

  &::placeholder {
    color: #999;
  }
`;

const ModernButton = styled.button`
  padding: 10px 18px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 16px rgba(102, 126, 234, 0.3);
  }

  &:active {
    transform: translateY(0px);
  }
`;

const ClearButton = styled.button`
  padding: 10px 14px;
  border: 2px solid #ccc;
  border-radius: 8px;
  background: #fff;
  color: #666;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #999;
    color: #333;
  }
`;

const FilterButtonContainer = styled.div`
  display: flex;
  gap: 8px;
`;

const FilterToggleButton = styled.button`
  padding: 10px 16px;
  border: 2px solid #667eea;
  border-radius: 8px;
  background: ${props => props.isOpen ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : '#ffffff'};
  color: ${props => props.isOpen ? '#ffffff' : '#667eea'};
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(102, 126, 234, 0.2);
  }
`;

const FilterPanel = styled.div`
  background: linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%);
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #e8eef5;
`;

const FilterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
`;

const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const FilterLabel = styled.label`
  font-weight: 600;
  color: #333;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
`;

const FilterLink = styled(Link)`
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 13px;
  color: #555;
  text-decoration: none;
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.2s ease;

  &:hover {
    background: linear-gradient(135deg, #f0f4ff 0%, #f8f5ff 100%);
    color: #667eea;
    text-decoration: none;
    padding-left: 16px;
  }

  &.selected {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    font-weight: 600;
  }
`;

const mapStateToProps = (state) => {
    return {
        isFetching: state.actorCardReducers.isFetching.count,
        tags: state.actorCardReducers.tags
    }
}

export default connect(mapStateToProps)(FilterActor);